module.exports = __webpack_public_path__ + "img/heart-full-prm.006cda17.svg";